export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.29-1246.30",
  commitId: "220749f3be4c01b37280a4187794c66797c256ca",
  commitTime: "2026-05-29T12:46:30.000Z",
});
